import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EditArt } from 'src/app/_interfaces/EditArt';
import { AFSInputType, FeedbackService, MsgType } from 'src/app/_provider/feedback.service';
import { PopoverListItem, PopoverPage } from 'src/app/_template/popover/popover.page';
import { Attachment } from '../../../../_interfaces/Attachment';
import { HttpFunctionResult } from '../../../../_interfaces/HttpFunctionResult';
import { FilesService } from '../../../../_provider/files.service';
import { Camera, CameraResultType, Photo } from '@capacitor/camera';
import { Platform } from '@ionic/angular';
import { TicketEmployee} from 'src/app/_provider/tickets/ticket.service';
import { ArticlePage } from 'src/app/_pages/article/article.page';
import { Article } from 'src/app/_interfaces/article';
import { AuthService, ROLE } from 'src/app/_provider/auth.service';
import { TicketServiceBase } from 'src/app/_provider/tickets/ticketBase.service';
import { TicketCustomer } from 'src/app/_provider/tickets/ticketCustumer.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { DeviceSelectPage } from 'src/app/_pages/device-select/device-select.page';
import { Device } from 'src/app/_provider/devices/device.type';
import { DevicesService } from 'src/app/_provider/devices/devices.service';

@Component({
  selector: 'app-assets-add',
  templateUrl: './assets-add.component.html',
  styleUrls: ['./assets-add.component.scss'],
})
export class AssetsAddComponent implements OnInit {

  @Output() newFile: EventEmitter<Attachment> = new EventEmitter<Attachment>(null)
  @Input() isDarkmode: boolean

  @ViewChild("file", {static: true}) file: any

  private ticketSrv: TicketServiceBase

  public loading: boolean = false
  constructor(
    public filesSrv: FilesService,
    private elementRef: ElementRef,
    private platform: Platform,
    private ticketSrvEmployee: TicketEmployee.TicketService,
    private ticketSrvCustomer: TicketCustomer.TicketService,
    private feedback: FeedbackService,
    private general: GeneralService,
    private authSrv: AuthService,
    private deviceSrv: DevicesService
  ) { 
    this.ticketSrv = this.authSrv.role == ROLE.employee ? this.ticketSrvEmployee : this.ticketSrvCustomer
  }

  ngOnInit() {}

  public async clickFileSelect(event: Event){
    if(this.authSrv.role == ROLE.customer) {
      if(this.loading) return
      return this.elementRef.nativeElement.querySelector("#file").click()
    } 
    

    const list: PopoverListItem[] = [
      {id: 2, description: "Datei", icon: "fa-file"}
    ]
    if(this.platform.is("capacitor")) list.unshift({id: 1, description: "Bild", icon: "fa-image"})
    if(this.general.webConfig.hasManagerConnection) {
      list.unshift({id: 0, description: "Artikel", icon: "fa-box"})
      list.push({id: 3, description: "Gerät", icon: "fa-gears"})
    }

    await this.feedback.openPopover<EditArt>(PopoverPage, event, {list: list}, async (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return

      //1 = Artikel
      //2 = Bild bei capacitor; Datei bei Weby
      switch (result.data.id) {
        case 0:
        await this.addArticle()
          break;
        case 1: 
          await this.addFromCamera()
          break;
        case 3: 
          await this.addDevice()
          break;
        default:
          if(this.loading) return
          this.elementRef.nativeElement.querySelector("#file").click()
          break
      }
    })
    
  }

  public async addArticle(){

    const result: HttpFunctionResult<Article> = await this.feedback.showModal({
      id: "articleSelect",
      component: ArticlePage
    })

    if(!result.success) return

    await this.feedback.showLoading(async () => {
      const uploadResponse: HttpFunctionResult<number> = await this.filesSrv.saveArticleToTicket(result.data)
      if(!uploadResponse.success) return
      this.addFile({
        id: uploadResponse.data,
        description: result.data.description,
        type: "Artikel",
        calculated: false,
        serialNumbersRequired: result.data.serialNumbersRequired,
        toCalculate: result.data.toCalculate,
        quantity: result.data.quantity,
        serialNumbers: result.data?.serialNumbers ?? []
      })
    })
  }

  public async uploadFile(dataSet: any){

    const file: File = dataSet.files[0]

    if(this.loading) return
    this.loading = true
    const result: HttpFunctionResult<number> = await this.filesSrv.uploadFile(file)
    this.loading = false
    this.filesSrv.uploadProgress = 0
    if(result.success)
    this.addFile({
      id: result.data,
      description: file.name,
      type: "Datei"
    })
  }

  public async addFromCamera(){
    if(await Camera.checkPermissions()){
      const image: Photo = (await Camera.getPhoto({
        presentationStyle: "fullscreen",
        // source: CameraSource.Camera,
        promptLabelPhoto: "Galerie",
        promptLabelPicture: "Kamera",
        promptLabelCancel: "Abbrechen",
        promptLabelHeader: "Bild",
        quality: 100,
        allowEditing: false,
        resultType: CameraResultType.Base64
      }))
      const inputResult: HttpFunctionResult<string> = await this.feedback.showInput({
        header: "Dateiname",
        message: "Bitte geben Sie ein Namen für das Bild ein.",
        placeholder: "Dateiname...",
        type: AFSInputType.TEXT,
        autofocus: true
      })

      if(!inputResult.success) return


      try {
        const res: Response = await fetch("data:image/jpeg;base64," + image.base64String)
        const blob: Blob = await res.blob()
        const file: File = new File([blob], `${inputResult.data}.jpeg`, {type: "image/jpeg"})
        
        await this.feedback.updateLoading("Hochladen...")
        const result: HttpFunctionResult<number> = await this.filesSrv.uploadFile(file)
        if(result.success)
        this.addFile({
          id: result.data,
          description: file.name,
          type: "Datei"
        })
      } catch (error) {
        await this.feedback.showMsg(MsgType.Error, JSON.stringify(error))
      }
      await this.feedback.hideLoading()

    }
  }

  public addFile(file: Attachment){
    if(file) this.ticketSrv.addFile(file)
  }

  private async addDevice(){
    const result: HttpFunctionResult<Device> = await this.feedback.showModal({
      component: DeviceSelectPage,
      componentProps: {
        addressId: this.ticketSrv.ticket?.address?.managerId || -1
      }
    })

    if(!result.success) return

    await this.feedback.showLoading(async () => {
      const createResult: HttpFunctionResult<number> = await this.deviceSrv.addDeviceToTicket(result.data, this.ticketSrv.ticket.id, this.ticketSrv.activeWorkstepId)
      if(createResult.success) this.addFile({
        id: createResult.data,
        description: result.data.description,
        type: "Geräte",
        workstepId: this.ticketSrv.activeWorkstepId
      })
    }, "Gerät wird hinzugefügt...")
    
    
  }
}
